module.exports = __webpack_public_path__ + "static/media/DoctorStrange.d5a2edec.jpg";